module.exports = __webpack_public_path__ + "static/media/icon-refresh-on.c978dc49.svg";